import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="report-reason"
export default class extends Controller {
  static targets = ["textarea"]
  static values = { other: String }

  connect() {
    this.updateTextareaVisibility()
  }

  toggle() {
    this.updateTextareaVisibility()
  }

  updateTextareaVisibility() {
    if (this.isOtherSelected()) {
      this.textareaTarget.classList.remove("hidden")
    } else {
      this.textareaTarget.classList.add("hidden")
    }
  }

  isOtherSelected() {
    return this.selectedReason() === this.otherValue
  }

  selectedReason() {
    const checkedRadio = this.element.querySelector("input[type=radio]:checked")
    return checkedRadio ? checkedRadio.value : null
  }
}
